document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('hero-scroll-btn');
  if (btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      // Hero'dan sonraki ilk section'a kaydır
      var heroSection = document.querySelector('.hero-wrapper');
      if (heroSection) {
        var nextSection = heroSection.nextElementSibling;
        if (nextSection) {
          nextSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  let variantTouched = false;

  const picker = document.querySelector("variant-picker, variant-picker-component, .variant-picker");
  const form = document.querySelector('form[action*="/cart/add"]');

  if (!picker || !form) return;

  picker.addEventListener("click", function (e) {
    if (e.target.closest('input[type="radio"], label')) {
      variantTouched = true;
      closeVariantModal();
    }
  });

  function getOptionName() {
    const text = picker.innerText.toLowerCase();
    if (text.includes("beden")) return "beden";
    if (text.includes("numara")) return "numara";
    if (text.includes("renk")) return "renk";
    return "seçenek";
  }

  function showVariantModal() {
    closeVariantModal();

    const modal = document.createElement("div");
    modal.className = "variant-modal-overlay";
    modal.innerHTML = `
      <div class="variant-modal-box">
        <div class="variant-modal-icon">!</div>
        <div class="variant-modal-title">Seçim yapmanız gerekiyor</div>
        <div class="variant-modal-text">Lütfen ${getOptionName()} seçimi yapınız.</div>
        <button type="button" class="variant-modal-button">Tamam</button>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector(".variant-modal-button").addEventListener("click", closeVariantModal);
    modal.addEventListener("click", function (e) {
      if (e.target === modal) closeVariantModal();
    });
  }

  function closeVariantModal() {
    const old = document.querySelector(".variant-modal-overlay");
    if (old) old.remove();
  }

  function blockIfNeeded(e) {
    if (variantTouched) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    showVariantModal();

    return false;
  }

  document.addEventListener(
    "click",
    function (e) {
      const button = e.target.closest(
        'button[type="submit"], button[name="add"], .shopify-payment-button button'
      );

      if (!button) return;

      const isProductButton =
        button.closest('form[action*="/cart/add"]') ||
        button.closest(".shopify-payment-button");

      if (!isProductButton) return;

      blockIfNeeded(e);
    },
    true
  );

  form.addEventListener("submit", blockIfNeeded, true);
});
